<template>
  <div id="yoga-admin" class="yoga-admin-container">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>


<style lang="scss">
.yoga-admin-container {
  max-width: 1600px;
  margin: 0 auto;
  direction: rtl;
  text-align: right;
  font-family: Arial, Helvetica, sans-serif;
}
</style>
